// 参照antd 设计个默认主题
// https://github.com/ant-design/ant-design/blob/master/components/style/themes/default.less
export var themeColor={bgColor:'#fff',titleColor:'#222',//标题字体颜色
titleSize:'',titleTextIcon:'',titleTextSlide:'',titleText3D:'',titleTextWhirl:'',borderRadius:'6px',closeIconColor:'#999',// 右上角关闭按钮颜色
slideBgColor:'#fff',//滑块背景色
slideBorderRadius:'4px',//滑块圆角
slideIconColor:'#B3B5B7',//滑块icon颜色
slideBorderColor:'rgba(0, 0, 0, 0.2)',//滑块边距颜色
slideSlotBorderRadius:'',//滑块槽圆角
slideSlotBgColor:'#f4f5f6',//滑块槽背景色
slidingSlotBgColor:'rgb(194, 237, 216)',// 滑块划过的槽背景色
slidingSlotErrorBgColor:'rgb(255, 193, 193)',// 验证失败时滑块划过的槽背景色
slidingSlotLinearColor:'',// 如果设置了该渐变项，需要设置下slidingSlotBgEndColor
slidingSlotBgStartColor:'',slidingSlotBgEndColor:'',// 如果设置了slidingSlotLinearColor，需要设置下slidingSlotBgEndColor，因为滑块背景背景依赖
slideSlotDescColor:'#999',//滑块说明文案字体颜色
// 文案扫光效果支持
shineTextFillColor:'rgba(0, 0, 0, 0.3)',shineBlockStartColor:'rgba(0, 0, 0, 0)',shineBlockEndColor:'#222',imgLoadingIcon:'',imgLoadingErrorIconColor:'#CACACA',imgLoadingBgColor:'rgb(244, 245, 246)',//图片加载中背景色
imgLoadingTextColor:'rgb(202, 202, 202)',//图片加载中文案颜色
imgBorderRadius:'',//图片圆角
verifyMsgBgColor:'rgba(34, 34, 34, 0.85)',//验证通过或失败背景色
verifyIconColor:'#fff',verifyMsgColor:'#fff',dotBgColor:'rgb(240, 65, 66)',dotColor:'#fff',dotBorderColor:'#fff',whirlMaskBgc:'rgba(0, 0, 0, 0.50)',//环形验证码验证通过、失败、频繁请求时遮罩层颜色
refreshFontColor:'#505050',// 刷新文案颜色
refreshIconColor:'#505050',// 刷新icon颜色
sureBtnBgColor:'#f85959',//确定按钮背景颜色
sureBtnBgOpacity:0.5,//确定不可操作时按钮背景颜色透明度
sureBtnFontColor:'#fff',//确定按钮字体颜色
sureBtnBorderRadius:'4px',//确定按钮圆角
feedbackBgColor:'#fff',feedbackFontColor:'#505050',// 反馈文案颜色
feedbackIconColor:'#505050',// 反馈icon颜色
feedbackTitleColor:'#222222',// 反馈标题颜色
feedbackLineColor:'#e8e8e8',feedbackListColor:'#505050',// 反馈列表颜色
feedbackCloseIconColor:'#999',// 反馈右上角关闭按钮颜色
feedbackBtnBgColor:'#f85959',// 反馈确认按钮背景色
feedbackBtnBgOpacity:0.5,// 反馈确认不可操作时按钮背景颜色透明度
feedbackBtnFontColor:'#fff',// 反馈确认按钮字体颜色,
feedbackBtnBorderRadius:'4px',feedbackOnSelectedIconColor:'#FF5E5E',// 反馈选项选中颜色
feedbackUnSelectedIconColor:'#D8D8D8',// 反馈选项未许那种颜色
voiceIconColor:'#C4C4C4',// 声音 icon 颜色（三条白线颜色）
voiceBgIconColor:'#F04142',// 声音 icon 背景色 （目前是红色背景）
voiceIconUrl:'',// 声音 icon url
voiceInputBgColor:'',// 输入框背景色
voiceInputColor:'',// 输入框输入文字颜色
voiceInputPlaceholderColor:'',// 输入框提示语颜色
voiceInputCaretColor:'',// 输入框光标颜色
voiceMobileBtn1Color:'',// voice btn1 对应两个按钮时的左侧红色按钮 和 只有一个按钮时的按钮
voiceMobileBtn2Color:'',// voice btn2 两个按钮时右侧的按钮
voiceWebBtn1Color:'',voiceWebBtn2Color:'',voiceWebBtn1BgColor:'',voiceWebBtn2BgColor:'',voiceWebBtn1BorderColor:'',voiceWebBtn2BorderColor:'',voiceMobileMistakeIconColor:'#222222',// mobile 错误 icon 颜色
voiceWebMistakeIconColor:'#F04142',// web 错误 icon 颜色
voiceMistakeIconUrl:'',// 错误 icon url
voiceMobileSuccessIconColor:'black',// mobile 成功 icon 颜色
voiceWebSuccessIconColor:'#00AA54',// web 成功 icon 颜色
voiceSuccessIconUrl:'',// 成功 icon url
voiceLoadingIconUrl:''// loading icon url
};export default(function(options){var theme=Object.keys(themeColor).reduce(function(themeColor,key){if(options[key]){themeColor[key]=options[key];}return themeColor;},themeColor);theme.slidingSlotBgStartColor=theme.slidingSlotBgColor;theme.slidingSlotBgEndColor=(!!theme.slidingSlotLinearColor?theme.slidingSlotBgEndColor:theme.slidingSlotBgColor)||theme.slidingSlotBgColor;return theme;});